/** True when both lists hold the same ids, regardless of order. */
export function areSameIds(a: string[], b: string[]) {
  if (a.length !== b.length) return false;

  const aSorted = [...a].sort();
  const bSorted = [...b].sort();
  return aSorted.every((id, index) => id === bSorted[index]);
}
